
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/tech-crunch",
      function () {
        return require("private-next-pages/blogs/tech-crunch.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs/tech-crunch"])
      });
    }
  